import React, {useState, useContext, useEffect} from 'react'
import TextFields_Outlined from '../TextFields_Outlined';
import RadioButtonsGroup from '../RadioButtonsGroup'

/* FX */
import FadeIn from '../FadeIn'

/* */
import {TranslationColumn1Context} from '../TranslationContexts/TranslationColumn1Context'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';

const TranslationContent_SchoolDocument = ({triggerUpdateFromParent, required, updateProgressBar, valueInField, classesToAdd}) => {
    //const { setCol1RequiredFields } = useContext(TranslationColumn1Context)
    //let iepTextVal = "";

    const { col1RequiredFields, setCol1RequiredFields } = useContext(TranslationColumn1Context)
    
    // For unmounting
    useEffect(() => {
        return;
        var temp = col1RequiredFields;
        temp.schoolDocumentText = "";
        setCol1RequiredFields(temp)
        // We also need to re-run the progress bar becaues there's been an update
        updateProgressBar()
       // returned function will be called on component unmount 
       return () => {
        var temp = col1RequiredFields;
        delete temp.schoolDocumentText;
        setCol1RequiredFields(temp)
        // We also need to re-run the progress bar becaues there's been an update
        updateProgressBar()
       }
      }, [])
      
      function triggerUpdateInParent(id, value ){
        triggerUpdateFromParent(id, value)
        return;
          var temp = col1RequiredFields;
          setCol1RequiredFields(temp)
          triggerUpdateFromParent(id, value)
      }

    return (
        <Row>
            
            <Col>
                <FadeIn delay={100} duration={250}>
                    <br/>
                    <TextFields_Outlined defaultValue={valueInField} classesToAdd={classesToAdd} required={required} triggerUpdateInParent={triggerUpdateFromParent} id="schoolDocumentText" label="School Document Title"/>
                </FadeIn>
            </Col>
            <Col>
                <FadeIn delay={100} duration={250}>
                    <RadioButtonsGroup triggerUpdateInParent={triggerUpdateFromParent} 
                        groupLabel="School Document Type" 
                        defaultValue="Calendar"
                        classesToAdd={classesToAdd}
                        radioButtons={["Calendar","Flyer","Letter","Handbook","Health Forms","Permission Slip","Schedules"]}/>
                </FadeIn>
            </Col>
        </Row>
    )
}

export default TranslationContent_SchoolDocument
